module.exports = __webpack_public_path__ + "assets/img/17_942.0cedd20a.jpg";